import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from "rxjs/operators";
import {RestUrlsConfig} from '@signature-it/ngx-generic/config';
import {CampaignDTO} from "@signature-it/ngx-catalogue/models";

@Injectable({
    providedIn: 'root'
})
export class CampaignService {

    constructor(
        protected http: HttpClient,
        protected restUrlsConfig: RestUrlsConfig) {
    }

    getCampaignData(campaign): Observable<any[]> {
        return this.http.get<any[]>(`${this.restUrlsConfig.appURL}/public/campaign/${campaign}`)
            .pipe(map((res) => res), catchError((error: any) => throwError(error)));
    }
}
